'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var LOG_STATUS = {
  'error-001': 'Unable to load iframe',
  'error-002': 'Timeout loading iframe',
  'error-003': 'Missing access token',
  'error-004': 'Possible loop',
  'error-005': 'Login options are misconfigured. Set useIframe: true and/or redirect: true',
  'error-006': 'An error is present in the response URL hash',
};

function logError(status, error) {
  if ( error === void 0 ) error = '';

  var errorLog = {
    service: 'OauthJS',
    status: ("oauthjs-" + status),
    statusText: LOG_STATUS[status]
  };

  if (error) {
    errorLog.error = error;
  }

  return errorLog;
}

function toUrlParams(obj) {
  return Object.keys(obj).map(function(key) {
    return encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]);
  }).join('&');
}

function randomString(length) {
  var bytes = new Uint8Array(length);
  var crypto = window.crypto || window.msCrypto;
  var random = crypto.getRandomValues(bytes);
  var result = [];
  var charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._~';
  for (var i = 0; i < random.length; i++) {
    var c = random[i];
    result.push(charset[c % charset.length]);
  }
  return result.join('');
}

function createCookie(name, value, days) {
  var cookie;
  var date = new Date();
  var baseDomain = getLocation().hostname.split('.').slice(-2).join('.');

  date.setTime(date.getTime() + ((days || 30) * 864e5));
  var expires = date.toGMTString();
  cookie = encodeURIComponent(name) + '=' + value + ';expires=' + expires + ';path=/';

  if (baseDomain.indexOf('.') !== -1) {
    cookie += ';domain=' + baseDomain;
  }

  window.document.cookie = cookie;
}

function hash2Obj(hash) {
  if (hash) {
    return hash
      .slice(1)
      .replace(/^\//, '')
      .split(/[&?]/)
      .map( function (el) { return el.split('='); } )
      .reduce( function (pre, cur) {
        var key = cur[0];
        var val = cur[1];
        pre[key] = val;
        return pre;
      }, {} );
  }
  return {};
}

function redirect(url) {
  window.location.replace(url);
}

function now() {
  return window.Date.now();
}

function getLocation() {
  return window.location;
}

function getLocationOrigin() {
  var loc = getLocation();

  return (loc.protocol) + "//" + (loc.hostname) + (loc.port ? (":" + (loc.port)) : '');
}

function isInIframe() {
  return window.self !== window.parent;
}

function assign(target, varArgs) { // .length of export function is 2
  var arguments$1 = arguments;

  /* istanbul ignore if */
  if (target == null) { // TypeError if undefined or null
    throw new TypeError('Cannot convert undefined or null to object');
  }

  var to = Object(target);

  for (var index = 1; index < arguments.length; index++) {
    var nextSource = arguments$1[index];

    if (nextSource != null) { // Skip over if undefined or null
      for (var nextKey in nextSource) {
        // Avoid bugs when hasOwnProperty is shadowed
        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
          to[nextKey] = nextSource[nextKey];
        }
      }
    }
  }
  return to;
}

var cache = {};

function get(storageKey) {
  if (getStorage() && !cache[storageKey]) {
    var item = getStorage().getItem(storageKey);
    if (item) {
      try {
        cache[storageKey] = JSON.parse(item);
      } catch (e) {
        cache[storageKey] = item;
      }
    }
  }
  return cache[storageKey] || null;
}

function set(storageKey, data) {
  if (getStorage()) {
    cache[storageKey] = data;
    getStorage().setItem(storageKey, JSON.stringify(data));
  }
}

function clear(storageKey) {
  if (getStorage()) {
    cache = {};
    getStorage().removeItem(storageKey);
  }
}

function update(storageKey, data) {
  var current = get(storageKey) || {};
  assign(current, data);
  set(storageKey, current);
}

function getStorage() {
  try {
    return window.localStorage;
  } catch (e) {
    console.warn('No local storage', e);
    return null;
  }
}

var authInterval;
/*
 * Continually check is isAuth cookie in case they sign out from
 * another tab or from global nav.
*/
function watchAuthCookie() {
  clearInterval(authInterval);
  authInterval = setInterval(checkAuthedState, 1000);
}

/**
 * Returns true if the user is authenticated (isAuth cookie is 1). Otherwise, returns false.
 * @alias isAuthed
 * @return {boolean} - Whether user is currently authenticated
 * @example
 * Oauth.isAuthed();
 */
function hasCookie() {
  return window.document.cookie.indexOf('isAuth=1') >= 0;
}

function createCookie$1() {
  createCookie('isAuth', '1', 7);
  watchAuthCookie();
}

function clear$1() {
  createCookie('isAuth', '0', 7);
}

function checkAuthedState() {
  if (!hasCookie() && authInterval) {
    notifyAuthChanged();
  }
}

function expiresAt(expiresIn) {
  // Lower by 60 seconds for buffer
  return now() + (parseInt(expiresIn, 10) - 60) * 1000;
}

function isExpired(accessTokenExpiresAt) {
  return accessTokenExpiresAt === undefined ? true : accessTokenExpiresAt - now() <= 0;
}

var authChangedSubscribers = [];

function notifyAuthChanged() {
  clearInterval(authInterval);
  authInterval = false;
  authChangedSubscribers.forEach(function (authChangedSubscriber) { return authChangedSubscriber(); });
}

/**
 * subscribes a callback function to be fired when the `isAuth` cookie changes from 1 to 0.
 *
 * This method is useful for performing any action in the event that a user is no longer authenticated.
 *
 * OauthJS will begin watching for changes to the `isAuth` cookie immediately after a call to `#login` is successful.
 * @alias onAuthRevoke
 * @param {function} callback - The callback to be executed when isAuth cookie changes to 0 (user is not authenticated)
 * @return {undefined}
 * @example
 * // Scenario: A user is logged in to her Xfinity account,
 * // then she logs out from another tab.
 * Oauth.onAuthRevoke(function() {
 *   // User is no longer authenticated. Clear Oauth info from storage
 *   Oauth.clear({
 *     clientId: 'scion-local',
 *     authorizeUrl: 'https://oauth.xfinity.com/oauth/authorize'
 *   });
 *   // display a notification to user
 * });
 */
function subscribe(callback) {
  authChangedSubscribers.push(callback);
}

function getParams(options) {
  var params = options.authOpts || {};

  return assign(params, {
    client_id: options.clientId,
    redirect_uri: /^https?/.test(options.authOpts.redirect_uri)
      ? options.authOpts.redirect_uri
      : getLocationOrigin() + (options.authOpts.redirect_uri || ''),
    state: getLocation().href,
    nonce: randomString(16),
  });
}

function ableToLogin(options) {
  var key = 'oauthLastAuth' + options.authorizeUrl;
  var lastAuth = get(key) || { time: 0 };
  var prompt = options.authOpts.prompt;
  var ableToLogin = !isInALoop(lastAuth, prompt);
  set(key, {
    time: now(),
    prompt: prompt
  });

  return ableToLogin;
}

// Prevent infinite loop logging in
function isInALoop(lastAuth, currentPrompt) {
  var threeSeconds = 3000;
  var withinThreeSeconds = parseInt(lastAuth.time, 10) + threeSeconds > now();
  var hasSamePrompt = lastAuth.prompt === currentPrompt;

  // is only a loop if previous login is within 3s AND if prompt is the same
  return withinThreeSeconds && hasSamePrompt;
}

/**
 * The code was extracted from:
 * https://github.com/davidchambers/Base64.js
 */

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function InvalidCharacterError(message) {
  this.message = message;
}

InvalidCharacterError.prototype = new Error();
InvalidCharacterError.prototype.name = 'InvalidCharacterError';

function polyfill (input) {
  var str = String(input).replace(/=+$/, '');
  if (str.length % 4 == 1) {
    throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
  }
  for (
    // initialize result and counters
    var bc = 0, bs, buffer, idx = 0, output = '';
    // get next character
    buffer = str.charAt(idx++);
    // character found in table? initialize bit storage and add its ascii value;
    ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
      // and if not first of each 4 characters,
      // convert the first 8 bits to one ascii character
      bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
  ) {
    // try to find character in table (0-63, not found => -1)
    buffer = chars.indexOf(buffer);
  }
  return output;
}


var atob = typeof window !== 'undefined' && window.atob && window.atob.bind(window) || polyfill;

function b64DecodeUnicode(str) {
  return decodeURIComponent(atob(str).replace(/(.)/g, function (m, p) {
    var code = p.charCodeAt(0).toString(16).toUpperCase();
    if (code.length < 2) {
      code = '0' + code;
    }
    return '%' + code;
  }));
}

var base64_url_decode = function(str) {
  var output = str.replace(/-/g, "+").replace(/_/g, "/");
  switch (output.length % 4) {
    case 0:
      break;
    case 2:
      output += "==";
      break;
    case 3:
      output += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }

  try{
    return b64DecodeUnicode(output);
  } catch (err) {
    return atob(output);
  }
};

function InvalidTokenError(message) {
  this.message = message;
}

InvalidTokenError.prototype = new Error();
InvalidTokenError.prototype.name = 'InvalidTokenError';

var lib = function (token,options) {
  if (typeof token !== 'string') {
    throw new InvalidTokenError('Invalid token specified');
  }

  options = options || {};
  var pos = options.header === true ? 0 : 1;
  try {
    return JSON.parse(base64_url_decode(token.split('.')[pos]));
  } catch (e) {
    throw new InvalidTokenError('Invalid token specified: ' + e.message);
  }
};

var InvalidTokenError_1 = InvalidTokenError;
lib.InvalidTokenError = InvalidTokenError_1;

function verifyTime(tokenKey, maxAllowedTime) {
  return (now() - (tokenKey * 1e3)) > (maxAllowedTime || 2e5);
}

function forcedLoginTime(forceLogin, tokenInfo) {
  return !(forceLogin && verifyTime(tokenInfo.authTime));
}

function decode(idToken) {
  var token;
  try {
    token = lib(idToken);
  } catch (e) {
    return null;
  }

  return {
    clientId: token.aud,
    authTime: token.auth_time,
    issuedAt: token.iat,
    expires: token.exp,
    trackingId: token.tid || 'unknown',
    userType: token.user_type,
    acrClaimValue: token.acr,
    nonce: token.nonce,
    decodedToken: token,
  };
}

function verify(loginOptions, tokenInfo) {
  if (loginOptions && tokenInfo) {
    return loginOptions.clientId === tokenInfo.clientId
          && loginOptions.state === tokenInfo.state
          && forcedLoginTime(loginOptions.prompt === 'login', tokenInfo);
  }
  return false;
}

var iframe = document.createElement('iframe');
var iframeErr;

var embed = function () { return document.body.appendChild(iframe); };

var iframeTimeout = function (timeout) { return new Promise(function (res, rej) {
  setTimeout(function () {
    try {
      iframeErr.allow = iframe.allow;
      iframeErr.referrerPolicy = iframe.referrerPolicy;
      iframeErr.sandbox = iframe.sandbox.toString();
      iframeErr.html = iframe.outerHTML;
      iframeErr.tokenPath = iframe.contentWindow.document.location.href;
    } catch (tempE) {
      // supress errors from logging
    }
    rej(logError('error-002', iframeErr));
  }, timeout);
}); };

var loadIframe = function (url) { return new Promise(function (resolve, reject) {
  iframeErr = {
    src: url,
    baseUrl: location.href,
    isTop: window === window.top
  };
  iframe.onload = function () {
    try {
      var token = iframe.contentWindow.document.location.hash;

      if (token) {
        resolve(token);
      } else {
        reject(logError('error-003'));
      }
    } catch (e) {
      // let iframe error fall through; timeout will catch
      iframeErr.exception = e;
      return;
    }

    document.body.removeChild(iframe);
  };

  iframe.onerror = function (e) {
    reject(logError('error-001', e));

    document.body.removeChild(iframe);
  };

  iframe.setAttribute('style', 'display: none;');
  iframe.src = url;

  if (document.body) {
    embed();
  } else {
    /* istanbul ignore next */
    document.addEventListener('DOMContentLoaded', embed);
  }
}); };

function login(url, timeout) {
  return Promise.race([iframeTimeout(timeout), loadIframe(url)]);
}

function getOauthInfo(loginOptions) {
  return getOauthInfoFromHash({ hash: window.document.location.hash, loginOptions: loginOptions })
         || getOauthInfoFromStorage(loginOptions) || {};
}

function createOauthInfo(ref) {
  var hashParams = ref.hashParams;
  var tokenInfo = ref.tokenInfo;
  var loginOptions = ref.loginOptions;

  return assign({}, {
    accessToken: hashParams.access_token,
    idToken: hashParams.id_token,
    accessTokenExpiresAt: expiresAt(hashParams.expires_in),
    enteredCredentials: tokenInfo.issuedAt - tokenInfo.authTime < 10,
    tokenInfo: tokenInfo,
    loginOptions: loginOptions
  });
}

function removeOauthParamsFromHash(hash) {
  var OAUTH_PARAM_REGEX = /access_token=|token_type=|id_token=|state=|expires_in=|nonce=|scope=|error=|error_description/;
  var newHash = hash.slice(1)
    .split('&')
    .filter(function (x) { return !OAUTH_PARAM_REGEX.test(x); })
    .join('&');
  var loc = getLocation();
  var search = loc.search;
  // calling `replaceState` '//' at the beginning of the path
  // will fail with a security error
  var pathname = loc.pathname.replace(/^\/{2,}/, '/');

  window.history.replaceState(window.history.state, '', ("" + pathname + search + (newHash ? ("#" + newHash) : '')));
}

function getOauthInfoFromHash(ref) {
  var hash = ref.hash;
  var loginOptions = ref.loginOptions;

  var hashParams = hash2Obj(hash);
  var tokenInfo = {};
  var maxAge = loginOptions.authOpts.max_age;
  var oauthInfo;

  !isInIframe() && Object.keys(hashParams).length && removeOauthParamsFromHash(hash);

  if (hashParams.access_token) {
    createCookie$1();

    if (hashParams.id_token) {
      tokenInfo = decode(hashParams.id_token);
      if (!verify(loginOptions, tokenInfo)) {
        clear$1();
        return {
          error: 'Token error: id_token failed to verify'
        };
      }
    } else {
      console.warn('No id token in response, see docs for more info.');
    }

    oauthInfo = createOauthInfo({ hashParams: hashParams, tokenInfo: tokenInfo, loginOptions: loginOptions });
    update(getStorageKey(loginOptions), oauthInfo);
    if (!isInIframe()) {
      oauthInfo.redirectedFrom = decodeURIComponent(hashParams.state);
    }
    oauthInfo.secure = (/Password/.test(tokenInfo.acrClaimValue) && oauthInfo.enteredCredentials) || isSecureAuthenticated(maxAge, oauthInfo.tokenInfo);

    if (oauthInfo.secure) {
      setSecureAuthTime();
    } else if (maxAge) {
      logout(assign({}, loginOptions, { redirect: false }));
      return undefined;
    }
    return oauthInfo;
  }
  if (hashParams.error) {
    if (hashParams.error === 'login_required') {
      return processLoginRequiredError();
    }
    return { error: hashParams.error };
  }
}

function processLoginRequiredError() {
/*
 * Third party cookies may be disabled in an iframe by security
 */
  var oauthInfo = { error: 'login required' };
  if (isInIframe()) {
    oauthInfo.error = 'Third party cookies may be disabled in iframes';
    return oauthInfo;
  }
  clear$1();
  return oauthInfo;
}

function getOauthInfoFromStorage(loginOptions) {
  var storageKey = getStorageKey(loginOptions);
  var maxAge = loginOptions.authOpts.max_age;
  var oauthInfo = get(storageKey);

  if (oauthInfo && hasCookie() && !isExpired(oauthInfo.accessTokenExpiresAt)) {
    if (oauthInfo.secure = isSecureAuthenticated(loginOptions.authOpts.max_age, oauthInfo.tokenInfo)) {
      setSecureAuthTime();
    } else if (maxAge) {
      logout(assign({}, loginOptions, { redirect: false }));
      return undefined;
    }
    return oauthInfo;
  }
}

function processOauthErrorResponse(ref) {
  var error = ref.error;
  var loginOptions = ref.loginOptions;

  if (error === 'login required' && loginOptions.redirect && !isInIframe()) {
    loginOptions.authOpts.prompt = 'login';
    var loginUrl = getLoginUrl(loginOptions);
    return Promise.reject(redirect(loginUrl));
  }
  return Promise.reject(logError('error-006', error));
}

function getStorageKey(loginOptions) {
  return loginOptions.clientId + loginOptions.authorizeUrl;
}

function performLogin(loginOptions) {
  var redirectUrl = getLoginUrl(loginOptions);
  var iframeLoginOpts = JSON.parse(JSON.stringify(loginOptions));

  if (!iframeLoginOpts.allowIframeLoginWithoutPromptNone) {
    iframeLoginOpts.authOpts.prompt = 'none';
  }
  iframeLoginOpts.authOpts.redirect_uri = iframeLoginOpts.iframeRedirectUri;
  var iframeLoginUrl = getLoginUrl(iframeLoginOpts);

  if (loginOptions.authOpts.max_age) {
    assign(loginOptions, { useIframe: false, redirect: true });
  }

  if (ableToLogin(loginOptions)) {
    if (loginOptions.useIframe && loginOptions.authOpts.prompt !== 'login') {
      return login(iframeLoginUrl, loginOptions.iframeTimeout).then(function (hash) {
        var oauthInfo = getOauthInfoFromHash({ hash: hash, loginOptions: loginOptions }) || {};
        if (oauthInfo.accessToken) {
          return Promise.resolve(oauthInfo);
        }
        if (oauthInfo.error) {
          return processOauthErrorResponse({ error: oauthInfo.error, loginOptions: loginOptions });
        }
        return Promise.reject(logError('error-003'));
      });
    }
    if (loginOptions.redirect) {
      return Promise.reject(redirect(redirectUrl));
    }
    return Promise.reject(logError('error-005'));
  }
  return Promise.reject(logError('error-004'));
}

function getDefaultOptions(options) {
  var defaultOptions = assign({}, {
    iframeRedirectUri: '/token.html',
    useIframe: true,
    redirect: true,
    allowIframeLoginWithoutPromptNone: false,
    iframeTimeout: 5000
  }, options);

  defaultOptions.authOpts = assign({}, {
    response_type: 'token',
  }, options.authOpts);

  return defaultOptions;
}

function isSecureAuthenticated(maxAge, tokenInfo) {
  return get('secureAuthTime') + maxAge * 1e3 > now() || tokenInfo.authTime + maxAge > now() / 1000;
}

/**
 * Sends user to authorize endpoint to get an accessToken.
 *
 The access token is cached and saved to `localStorage`. It will only attempt a login with iframe or redirect if the access token expires or `localStorage` is cleared.
 > **CIMA authorizeUrl**: https://oauth.xfinity.com/oauth/authorize
 >
 > **WebSec authorizeUrl**: https://websec-oic.cable.comcast.com/as/authorization.oauth2
 * @param {object} options
 * @param {string} options.clientId - Your clientId with oauth service
 * @param {string} options.authorizeUrl - URL to authorize with
 * @param {boolean} [options.allowIframeLoginWithoutPromptNone=false] - Prevents setting prompt=none before attempting an iframe login (NOT RECOMMENDED)
 * @param {string} [options.iframeRedirectUri=/token.html] - used as authOpts.redirect_uri for iframe login
 * @param {boolean} [options.redirect=true] - redirect user to authorizeUrl if silent auth fails
 * @param {boolean} [options.useIframe=true] - Whether to login via an iframe
 * @param {integer} [options.iframeTimeout=5000] - Timeout in milliseconds for iframe login attempt
 * @param {object} [options.authOpts] - Options for Open Id authentication
 * @param {string} [options.authOpts.acr_values] - ACR values
 * @param {integer} [options.authOpts.max_age] - Maximum Authentication Age
 * @param {string} [options.authOpts.prompt] - Whether to prompt at login. Values: 'none', 'login', 'select_billing_account', 'select_billing_account none', 'select_billing_account login'
 * @param {string} [options.authOpts.redirect_uri=document.location.pathname] - Where to return user to after auth. Can be relative or absolute path.
 * @param {string} [options.authOpts.response_type=token] - Requested type of response, space separated.
 * @param {string} [options.authOpts.scope] - Oauth requested scopes, space separated.
 * @return {promise} resolves with an object if successful. If unsuccessful, #login will redirect to the authorization endpoint or reject.
 *```javascript
 // resolved object
{
  accessToken,
  accessTokenExpiresAt,
  enteredCredentials,
  redirectedFrom, // only shows up after a redirect
  loginOptions: {
    // loginOptions passed to CIMA
  },
  // available if id_token is returned from CIMA
  tokenInfo: {
    clientId,
    authTime,
    issuedAt,
    expires,
    trackingId,
    userType,
    nonce,
    acrClaimValue,
    decodedToken: {
      // raw data returned from CIMA
    }
  }
};
```
 * @example
 * Oauth.login({
 *   clientId: 'scion-local',
 *   authorizeUrl: 'https://oauth.xfinity.com/oauth/authorize'
 * })
 * .then(info => console.log(info))
 * .catch(error => console.warn(error));
 */

function login$1(options) {
  if (!options || !options.clientId || !options.authorizeUrl) {
    throw new Error('argument must be an object with clientId and authorizeUrl properties');
  }
  var loginOptions = getDefaultOptions(options);
  var oauthInfo = getOauthInfo(loginOptions);

  if (oauthInfo.error) {
    return processOauthErrorResponse({ error: oauthInfo.error, loginOptions: loginOptions });
  }
  if (oauthInfo.accessToken) {
    return Promise.resolve(oauthInfo);
  }

  return performLogin(loginOptions);
}

/**
 * Gets the Login url for auth endpoint. Useful to set your own **`<a>`** tag.
 * @param {object} options
 * @param {string} options.clientId - Your clientId with oauth service
 * @param {string} options.authorizeUrl - URL to authorize with
 * @param {object} [options.authOpts] - Options for Oauth authentication, including `acr_values`, `max_age`, `prompt`, `redirect_uri`, `scopes`
 * @param {string} [options.authOpts.acr_values] - ACR values, see in Home Auth
 * @param {string} [options.authOpts.max_age] - Maximum Authentication Age. Specifies the allowable elapsed time in seconds since the last time the End-User was actively authenticated.
 * @param {string} [options.authOpts.prompt] - Whether oauth service should prompt user for a password. Set to 'login' to always ask for password. Set to 'select_billing_account' to always ask the end-user to select a user account.
 * @param {string} [options.authOpts.redirect_uri=document.location.pathname] - Where to return user to after auth. Can be relative or absolute path.
 * @param {string} [options.authOpts.response_type=token] - Requested type of response, space separated.
 * @param {string} [options.authOpts.scope] - Oauth requested scopes, space separated. You will automatically get the scopes requested by your clientId
 * @return {string} the `authorizeUrl` with the rest of the login options converted to url parameters.
 * @example
 * Oauth.getLoginUrl({
 *   clientId: 'scion-local',
 *   authorizeUrl: 'https://oauth.xfinity.com/oauth/authorize'
 * });
 */
function getLoginUrl(options) {
  if (!options || !options.clientId || !options.authorizeUrl) {
    throw new Error('argument must be an object with clientId and authorizeUrl properties');
  }
  var o = getDefaultOptions(options);
  var params = getParams(o);

  return o.authorizeUrl + '?' + toUrlParams(params);
}

/**
 * clears `localStorage` for current session, sets cookie to `isAuth=0`, and redirects to `logoutUrl`.
 * > **CIMA logoutUrl**: https://oauth.xfinity.com/oauth/sp-logout
 * >
 * > **WebSec logoutUrl**: https://extsso.cable.comcast.com/unprotect/logout/logout
 * @param {object} options
 * @param {string} options.clientId - Your clientId with oauth service
 * @param {string} options.authorizeUrl - URL to authorize with
 * @param {string} options.logoutUrl - URL to redirect to for logout
 * @param {boolean} options.redirect - Whether to redirect after clearing storage and auth cookie
 * @example
 * Oauth.logout({
 *   clientId: 'scion-local',
 *   authorizeUrl: 'https://oauth.xfinity.com/oauth/authorize',
 *   logoutUrl: 'https://oauth.xfinity.com/oauth/sp-logout'
 * });
 * // clear storage & auth cookie
 *  * Oauth.logout({
 *   clientId: 'scion-local',
 *   authorizeUrl: 'https://oauth.xfinity.com/oauth/authorize',
 *   redirect: false
 * });
 */
function logout(options) {
  if (!options || !options.clientId || !options.authorizeUrl) {
    throw new Error('argument must be an object with clientId and authorizeUrl properties');
  }
  var o = getDefaultOptions(options);
  clear(getStorageKey(o));
  clear('secureAuthTime');
  if (o.redirect) {
    clear$1();
    return redirect(o.logoutUrl);
  }
}

/**
 * Sets the current time into localStorage for secure auth flow.
 * The value saved is in 'secureAuthTime'
 * @example
 * Oauth.setSecureAuthTime()
 */
function setSecureAuthTime() {
  set('secureAuthTime', now());
}

exports.login = login$1;
exports.getLoginUrl = getLoginUrl;
exports.logout = logout;
exports.setSecureAuthTime = setSecureAuthTime;
exports.onAuthRevoke = subscribe;
exports.isAuthed = hasCookie;
